import AddTransactionFrom from "../../components/Admin/AddTransactionFrom";
import DashboardLayout from "../../components/Layout/DashboardLayout";

const AddNewTransaction = () => {
  return (
    <DashboardLayout pageTitle="Add New Details" mainClass="p-6">
      <div className="flex h-12 nav-bg p-3 text-white font-semibold rounded-tr rounded-tl">
        Add New Details
      </div>
      <div className="bg-white p-6 rounded-b shadow-md mx-auto">
        <AddTransactionFrom />
      </div>
    </DashboardLayout>
  );
};

export default AddNewTransaction;
